webpackJsonp([195351340454287],{

/***/ 2873:
/***/ (function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(2934);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ }),

/***/ 2888:
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(1135),
	    isArrayLike = __webpack_require__(80),
	    keys = __webpack_require__(105);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),

/***/ 2934:
/***/ (function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ }),

/***/ 2942:
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(2888),
	    findIndex = __webpack_require__(2943);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),

/***/ 2943:
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(1473),
	    baseIteratee = __webpack_require__(1135),
	    toInteger = __webpack_require__(2958);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),

/***/ 2957:
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(2959);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),

/***/ 2958:
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(2957);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),

/***/ 2959:
/***/ (function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(2873),
	    isObject = __webpack_require__(60),
	    isSymbol = __webpack_require__(1139);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),

/***/ 1279:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1594:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _PostSocialLinks = __webpack_require__(1394);
	
	var _PostSocialLinks2 = _interopRequireDefault(_PostSocialLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero(_ref) {
	  var classes = _ref.classes,
	      className = _ref.className,
	      post = _ref.post,
	      _ref$post = _ref.post,
	      publishDate = _ref$post.publishDate,
	      heroImage = _ref$post.heroImage,
	      title = _ref$post.title;
	  return _react2.default.createElement(
	    "div",
	    { className: (0, _classnames2.default)(classes.root, className) },
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "h1",
	        { className: classes.title },
	        title
	      ),
	      publishDate && _react2.default.createElement(
	        "div",
	        { className: classes.postDate },
	        _react2.default.createElement(
	          "span",
	          null,
	          "Published:"
	        ),
	        " ",
	        publishDate
	      ),
	      _react2.default.createElement(_PostSocialLinks2.default, { post: post, className: classes.social })
	    ),
	    heroImage && _react2.default.createElement("img", { src: heroImage.file.url, className: classes.image, alt: title })
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _root, _image;
	
	  return {
	    root: (_root = {
	      display: "flex",
	      flexWrap: "wrap",
	      alignItems: "center"
	
	    }, _root[theme.breakpoints[600]] = {
	      flexWrap: "nowrap"
	    }, _root),
	    title: {
	      fontSize: "28px",
	      fontWeight: "800",
	      lineHeight: "36px",
	      color: "#2E2E35"
	    },
	    postDate: {
	      fontSize: "14px",
	      color: "#9594A4",
	      marginTop: "16px"
	    },
	    social: {
	      marginTop: "32px"
	    },
	    image: (_image = {
	      flexShrink: "0",
	      maxWidth: "300px",
	      marginTop: "24px"
	
	    }, _image[theme.breakpoints[600]] = {
	      marginTop: "0",
	      marginLeft: "24px"
	    }, _image)
	  };
	})(Hero);
	module.exports = exports["default"];

/***/ }),

/***/ 1246:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	__webpack_require__(1279);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageBody = function PageBody(props) {
	  var thisHtml = '';
	  if (props.body !== null) {
	    thisHtml = props.body.childMarkdownRemark.html;
	  }
	
	  return _react2.default.createElement("div", {
	    className: (0, _classnames2.default)(props.classes.post, props.className),
	    dangerouslySetInnerHTML: { __html: thisHtml }
	  });
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    post: {
	      width: "100%",
	      color: "#413F48",
	      fontSize: "18px",
	      lineHeight: "1.6",
	      margin: "48px auto 16px auto",
	
	      "& h1": {
	        color: "#2E2E35",
	        fontWeight: "700",
	        letterSpacing: ".2px",
	        lineHeight: "1.2",
	        fontSize: "24px",
	        marginTop: "44px",
	        marginBottom: "12px"
	      },
	
	      "& h2": {
	        fontSize: "22px",
	        lineHeight: "1.4",
	        fontWeight: "700",
	        marginTop: "32px",
	        marginBottom: "12px"
	      },
	
	      "& h3": {
	        fontSize: "20px",
	        fontWeight: "700",
	        marginTop: "32px",
	        marginBottom: "12px"
	      },
	
	      "& h4": {
	        fontSize: "18px",
	        fontWeight: "600",
	        marginTop: "24px",
	        marginBottom: "12px"
	      },
	
	      "& a": {
	        color: "#2E2E35",
	        textDecoration: "underline"
	      },
	
	      "& em": {
	        fontStyle: "italic"
	      },
	
	      "& strong": {
	        fontWeight: "700"
	      },
	
	      "& ol": {
	        position: "relative",
	        counterReset: "item"
	      },
	
	      "& ol li": {
	        counterIncrement: "item",
	        paddingLeft: "24px",
	
	        "&:before": {
	          content: 'counter(item) "."',
	          position: "absolute",
	          left: "0",
	          fontWeight: "700"
	        }
	      },
	
	      "& ul": {
	        listStyleType: "disc"
	      },
	
	      "& ul li": {
	        marginLeft: "18px"
	      },
	
	      "& p": {
	        marginTop: "4px",
	        marginBottom: "8px"
	      },
	
	      "& img": {
	        display: "block",
	        maxWidth: "100%",
	        marginBottom: "16px"
	      }
	    }
	  };
	})(PageBody);
	module.exports = exports["default"];

/***/ }),

/***/ 1601:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PostPagination = function PostPagination(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: (0, _classnames2.default)(props.classes.root, props.className) },
	    props.previous && _react2.default.createElement(
	      _gatsbyLink2.default,
	      {
	        className: (0, _classnames2.default)(props.classes.postButton, props.classes.postButtonPrevious),
	        to: "/" + props.previous.slug + "/"
	      },
	      _react2.default.createElement(
	        "svg",
	        {
	          className: props.classes.arrow,
	          xmlns: "http://www.w3.org/2000/svg",
	          width: "18",
	          height: "18",
	          viewBox: "0 0 24 24"
	        },
	        _react2.default.createElement("path", { d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: props.classes.postLink },
	        "Prev Post"
	      )
	    ),
	    props.next && _react2.default.createElement(
	      _gatsbyLink2.default,
	      {
	        className: (0, _classnames2.default)(props.classes.postButton, props.classes.postButtonNext),
	        to: "/" + props.next.slug + "/"
	      },
	      _react2.default.createElement(
	        "span",
	        { className: props.classes.postLink },
	        "Next Post "
	      ),
	      _react2.default.createElement(
	        "svg",
	        {
	          className: props.classes.arrow,
	          xmlns: "http://www.w3.org/2000/svg",
	          width: "18",
	          height: "18",
	          viewBox: "0 0 24 24",
	          style: { color: "#F15953" }
	        },
	        _react2.default.createElement("path", { d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" })
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      display: "flex",
	      alignContent: "center",
	      marginTop: "20px"
	    },
	    postButton: {
	      display: "flex",
	      alignContent: "center",
	      justifyContent: "center",
	      backgroundColor: "#FFF4F0",
	      fontSize: "12px",
	      letterSpacing: ".25px",
	      color: "#F15953",
	      textDecoration: "none",
	      fontWeight: "700",
	      padding: "8px 16px",
	      borderRadius: "6px"
	    },
	    postButtonPrevious: {
	      marginRight: "auto"
	    },
	    postButtonNext: {
	      marginLeft: "auto"
	    },
	    arrow: {
	      fill: "#F15953"
	    },
	    postLink: {
	      marginTop: "3px",
	      padding: "0 3px"
	    }
	  };
	})(PostPagination);
	module.exports = exports["default"];

/***/ }),

/***/ 1394:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Facebook = __webpack_require__(126);
	
	var _Facebook2 = _interopRequireDefault(_Facebook);
	
	var _Twitter = __webpack_require__(137);
	
	var _Twitter2 = _interopRequireDefault(_Twitter);
	
	var _LinkedIn = __webpack_require__(130);
	
	var _LinkedIn2 = _interopRequireDefault(_LinkedIn);
	
	var _Pinterest = __webpack_require__(1186);
	
	var _Pinterest2 = _interopRequireDefault(_Pinterest);
	
	var _GooglePlus = __webpack_require__(1183);
	
	var _GooglePlus2 = _interopRequireDefault(_GooglePlus);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PostSocialLinks = function PostSocialLinks(_ref) {
	  var classes = _ref.classes,
	      className = _ref.className,
	      post = _ref.post;
	
	  return _react2.default.createElement(
	    "div",
	    { className: (0, _classnames2.default)(classes.root, className) },
	    _react2.default.createElement(
	      "a",
	      {
	        className: (0, _classnames2.default)(classes.icon, classes.facebook),
	        href: "https://www.facebook.com/sharer/sharer.php?u=" + _siteConfig2.default.siteUrl + "/" + post.slug + "&title=" + post.title,
	        target: "_blank",
	        rel: "noreferrer noopener"
	      },
	      _react2.default.createElement(_Facebook2.default, { size: 32 })
	    ),
	    _react2.default.createElement(
	      "a",
	      {
	        className: (0, _classnames2.default)(classes.icon, classes.twitter),
	        href: "https://twitter.com/intent/tweet?status=" + post.title + "+" + _siteConfig2.default.siteUrl + "/" + post.slug,
	        target: "_blank",
	        rel: "noreferrer noopener"
	      },
	      _react2.default.createElement(_Twitter2.default, { size: 32 })
	    ),
	    _react2.default.createElement(
	      "a",
	      {
	        className: (0, _classnames2.default)(classes.icon, classes.linkedin),
	        href: "https://www.linkedin.com/shareArticle?mini=true&url=" + _siteConfig2.default.siteUrl + "/" + post.slug + "&title=" + post.title,
	        target: "_blank",
	        rel: "noreferrer noopener"
	      },
	      _react2.default.createElement(_LinkedIn2.default, { size: 32 })
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  return {
	    root: {
	      display: "flex",
	      alignItems: "center",
	      width: "100%"
	    },
	    icon: {
	      margin: "0 2px",
	
	      "&:hover": {
	        color: "inherit",
	        opacity: "0.6"
	      }
	    },
	    facebook: {
	      color: theme.colors.facebook || "#000"
	    },
	    twitter: {
	      color: theme.colors.twitter || "#000"
	    },
	    linkedin: {
	      color: theme.colors.linkedin || "#000"
	    },
	    pinterest: {
	      color: theme.colors.pinterest || "#000"
	    },
	    google: {
	      color: theme.colors.google || "#000"
	    }
	  };
	})(PostSocialLinks);
	module.exports = exports["default"];

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TagList = function TagList(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: props.classes.postTagsContainer },
	    props.tags.map(function (tag) {
	      return _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          key: tag.id,
	          className: props.classes.postTagLink,
	          to: "/tag/" + tag.slug + "/"
	        },
	        tag.title
	      );
	    })
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _postTagsContainer;
	
	  return {
	    postTags: {},
	    postTagLink: {
	      fontSize: "10px",
	      lineHeight: "16px",
	      fontWeight: "800",
	      letterSpacing: ".5px",
	      textAlign: "center",
	      textDecoration: "none",
	      marginRight: "4px",
	      color: "#A9A8B6",
	      backgroundColor: "#ECECEC",
	      padding: "6px 12px",
	      borderRadius: "14px",
	
	      "&:hover": {
	        textDecoration: "none",
	        color: "#A9A8B6",
	        backgroundColor: "#dfdfdf"
	      }
	    },
	    postTagsContainer: (_postTagsContainer = {
	      display: "flex",
	      flexWrap: "wrap",
	      alignItems: "center",
	      padding: "20px 8px"
	
	    }, _postTagsContainer[theme.breakpoints[600]] = {
	      padding: "20px 0"
	    }, _postTagsContainer)
	  };
	})(TagList);
	module.exports = exports["default"];

/***/ }),

/***/ 1754:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _find = __webpack_require__(2942);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Hero = __webpack_require__(1594);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _PageBody = __webpack_require__(1246);
	
	var _PageBody2 = _interopRequireDefault(_PageBody);
	
	var _TagList = __webpack_require__(161);
	
	var _TagList2 = _interopRequireDefault(_TagList);
	
	var _PostPagination = __webpack_require__(1601);
	
	var _PostPagination2 = _interopRequireDefault(_PostPagination);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _PostSocialLinks = __webpack_require__(1394);
	
	var _PostSocialLinks2 = _interopRequireDefault(_PostSocialLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PostTemplate = function PostTemplate(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      _ref$data = _ref.data,
	      allContentfulPost = _ref$data.allContentfulPost,
	      contentfulPost = _ref$data.contentfulPost;
	  var title = contentfulPost.title,
	      slug = contentfulPost.slug,
	      id = contentfulPost.id,
	      body = contentfulPost.body,
	      tags = contentfulPost.tags;
	
	  var postNode = contentfulPost;
	
	  var postIndex = (0, _find2.default)(allContentfulPost.edges, function (_ref2) {
	    var post = _ref2.node;
	    return post.id === id;
	  });
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        title + " - " + _siteConfig2.default.siteTitle
	      )
	    ),
	    _react2.default.createElement(_SEO2.default, { pagePath: slug, postNode: postNode, postSEO: true }),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(_Hero2.default, { post: contentfulPost }),
	      _react2.default.createElement(_PageBody2.default, { body: body }),
	      tags && _react2.default.createElement(_TagList2.default, { tags: tags }),
	      _react2.default.createElement(_PostSocialLinks2.default, { className: classes.social, post: contentfulPost }),
	      _react2.default.createElement(_PostPagination2.default, { previous: postIndex.previous, next: postIndex.next })
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _root;
	
	  return {
	    root: (_root = {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      padding: "0 8px",
	      margin: "72px auto 96px auto"
	
	    }, _root[theme.breakpoints[600]] = {
	      maxWidth: "584px"
	    }, _root[theme.breakpoints[900]] = {
	      maxWidth: "700px"
	    }, _root),
	    social: {
	      justifyContent: "flex-end",
	      marginBottom: "24px"
	    }
	  };
	})(PostTemplate);

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-post-js-b6086f681ef52fc19baa.js